import webappInfo from 'src/webappInfo';

export function getFilteredTranslationsUrl(locale: string, cacheBuster?: string): string {
	return `/${webappInfo.name}/i18n/${locale}.json${cacheBuster ? `?${cacheBuster}` : ''}`;
}
